__turbopack_context__.v({
  "SliderRange": "xXhuFq_SliderRange",
  "SliderRoot": "xXhuFq_SliderRoot",
  "SliderThumb": "xXhuFq_SliderThumb",
  "SliderTrack": "xXhuFq_SliderTrack",
  "aside": "xXhuFq_aside",
  "btns": "xXhuFq_btns",
  "content": "xXhuFq_content",
  "contentShow": "xXhuFq_contentShow",
  "description": "xXhuFq_description",
  "filter": "xXhuFq_filter",
  "form": "xXhuFq_form",
  "label": "xXhuFq_label",
  "layout": "xXhuFq_layout",
  "overlay": "xXhuFq_overlay",
  "overlayShow": "xXhuFq_overlayShow",
  "pricegroup": "xXhuFq_pricegroup",
  "productImage": "xXhuFq_productImage",
  "products": "xXhuFq_products",
  "radio": "xXhuFq_radio",
  "title": "xXhuFq_title",
});
